<script lang="ts">
export default {
  name: 'KkImageModal',
}
</script>
<script setup lang="ts">
import { ref } from 'vue'
import Modal from '../../../../components/Modal.vue'
import { KkSiteIcon } from '../../../../components/base'

type Props = {
  images: Image[]
  selectedPhotoIndex: number | null
  siteType: string
  siteName: string
  storeName: string
  postedAt: string
  hideReportLink: boolean
}
type Image = {
  url: string
  report_url?: string
}
const props = withDefaults(defineProps<Props>(), {
  images: () => [],
  selectedPhotoIndex: null,
  siteType: '',
  siteName: '',
  storeName: '',
  postedAt: '',
  hideReportLink: false,
})

interface Emits {
  (e: 'closeImageModal'): void
}
const emit = defineEmits<Emits>()

const closePhotoModal = () => {
  emit('closeImageModal')
}

const shownPhotoIndex = ref<number>(0)
const prevPhoto = () => {
  if (shownPhotoIndex.value === 0) {
    shownPhotoIndex.value = props.images.length - 1
  } else {
    --shownPhotoIndex.value
  }
}
const nextPhoto = () => {
  if (shownPhotoIndex.value === props.images.length - 1) {
    shownPhotoIndex.value = 0
  } else {
    ++shownPhotoIndex.value
  }
}

/**
 * 写真付随テキスト
 * @param  { String } siteInterfaceName
 * @param  { String } siteName
 * @return { Object }
 */
const imageUrlText = (siteInterfaceName: string, siteName: string) => {
  return {
    'google': '問題を報告する',
    'yahoo_loco': '問題を報告する',
    'trip_advisor': `${siteName}で確認する`
  }[siteInterfaceName]
}

const load = (): void => {
  if (props.selectedPhotoIndex) shownPhotoIndex.value = props.selectedPhotoIndex
}
load()
</script>
<template>
  <div>
    <Modal option="photo" @close="closePhotoModal" @prev="prevPhoto" @next="nextPhoto">
      <div>
        <div :style="{ 'background-image': `url(${props.images[shownPhotoIndex].url})` }" class="image">
          <div class="p-photos__modal_info">
            <div class="p-photos__modal_info__store_name">
              {{ props.storeName }}
            </div>
            <div class="p-photos__site">
              <div class="p-photos__site__icon p-photos__site__icon__modal">
                <KkSiteIcon :name="props.siteType" />
              </div>
              <div class="p-photos__site__content">
                <div class="p-photos__site__name" v-text="props.siteName" />
                <div class="p-photos__site__postedAt" v-text="props.postedAt" />
              </div>
            </div>
            <div v-if="props.images[shownPhotoIndex].report_url && !props.hideReportLink" class="p-photos__modal_info__link_wrapper">
              <a :href="props.images[shownPhotoIndex].report_url" class="p-photos__modal_info__link" target="_blank">
                {{ imageUrlText(props.siteType, props.siteName) }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<style scoped lang="scss">
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';

.modalImage {
  margin: 0 auto;
  img {
    object-fit: contain;
    width: 90%;
    height: 100%;
  }
}
</style>
